module.exports = [
	{
		"link": "https://auth0.com/extend",
		"linkText": "Introducing Auth0 Extend. <i>Better platform extensibility for your SaaS.</i> <span>Read More</span>",
		"iconColor": "3445DC",
		"probability": 0.3333333333333333
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/ribbon-messages.json
// module id = 96
// module chunks = 0